<template>
    <div id="about-us-layout">
        <section id="about-section" class="light">
            <div class="container">
                <div class="row">
                    <div class="col-12 col-md-10 ml-auto mr-auto">
                        <h1>
                            Truestock is a locally owned
                            <nobr>co-operative</nobr>
                            . We're here to champion the representation of a truly diverse and beautiful Aotearoa, through our stock imagery.
                        </h1>
                    </div>
                </div>
            </div>
        </section>

        <section id="about-section-details" class="dark">
            <div class="container">
                <div class="row">
                    <div class="col-12 col-lg-4 description-left">
                        Why a co-operative and not a company?
                    </div>
                    <div class="col-12 col-lg-8 description-right">
                        Being a co-operative puts more power in the hands of the content creators. This way they are not only just contributors who get one of the highest commissions in the world, but also a share of the profit and voting
                        rights on the direction of the co-operative. They are the majority owners of Truestock. We also have proactive strategies in place to ensure fair pay for the everyday Kiwis you see in the photos. We are members
                        of Cooperative Business New Zealand.
                    </div>
                    <div class="col-12 col-lg-4 description-left">
                        Exclusive local Images available Royalty-free.
                    </div>
                    <div class="col-12 col-lg-8 description-right">
                        The images you see on Truestock are all exclusive to us. We give you access to freshly shot, diverse content in a variety of size options to choose. Images are Royalty-free making them easy to use across online and
                        print applications. We also offer exclusive use licenses for our images and are happy to discuss pricing based on the time frame of exclusivity needed.
                    </div>
                </div>
            </div>
        </section>

        <section id="about-section-second" class="dark">
            <div class="container">
                <div class="row">
                    <div class="col-12 col-lg-4 description-left">
                        Need help with something specific?
                    </div>
                    <div class="col-12 col-lg-8 description-right">
                        We work with the creative sector and businesses to capture specific stock photography based on particular requirements. With a large number of experienced contributors spread across New Zealand, we are happy to have
                        a discussion about your stock imagery needs.

                        <strong>Please email us at
                            <b-link v-b-modal.contact-modal>contact@truestock.co.nz</b-link>
                            to start a conversation. We look forward to hearing from you.</strong>
                    </div>
                </div>
            </div>
        </section>

        <section id="profile-section" class="light">
            <div class="container">
                <div class="row">
                    <div class="col-12 col-sm-3">
                        <img :src="`${assetsUrl}profile-photos/tan-profile.jpg`" alt="Tanmay Desai">
                        <div class="info">
                            <div><strong>Tanmay Desai</strong></div>
                            <div>CEO, Director</div>
                            <div>tan@truestock.co.nz</div>
                            <div>021 826 629</div>
                        </div>
                    </div>
                    <div class="col-12 col-sm-9">
                        <p>
                            An entrepreneur at heart with passion for the creative sector, I've been deeply involved with the New Zealand creative industry for over 15 years. Working with various design agencies and organisations, my
                            specialisation has been brand and identity work. Over the years I have had the pleasure of working with some very talented, unique and amazing people.
                            <br><br>
                            As a Kiwi-Indian, I can truly say that I've been humbled with the opportunities of working in a senior capacity on major rebrand & identity projects for iconic New Zealand businesses such as Fonterra, NZMP, All
                            Blacks Experience, Crusaders, Bank of New Zealand, Genesis Energy, Colorsteel, Jazz Apples (T&G), Te Aho O Te Kahu (Cancer Control Agency) and many more.
                            <br><br>
                            Being a Design Director I have been involved with not just graphic design but art directing multiple photoshoots for various New Zealand businesses small and big. I've worked with many talented local
                            photographers, marketers and producers on creating briefs, art directing sets and making sure we capture what's needed - on the day of the shoot! It's a skill set that will help us work well with our contributing
                            co-owners and clients at Truestock.
                        </p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 col-sm-3">
                        <img :src="`${assetsUrl}profile-photos/ovi-profile.jpg`" alt="Ovidii Alexeenco">
                        <div class="info">
                            <div><strong>Ovidii Alexeenco</strong></div>
                            <div>CIO, Director</div>
                            <div>ovi@truestock.co.nz</div>
                        </div>
                    </div>
                    <div class="col-12 col-sm-9">
                        <p>
                            I am a Software Engineer with over a decade of experience designing, building and delivering world class software platforms to businesses and end users. Having seen first hand the change a well designed platform
                            can bring to daily business, I am driven to see Aotearoa's creative sector thrive.
                            <br><br>
                            Over the last 12 years, I have worked with many businesses ranging from start-ups to large corporates. During this time, I have experienced many aspects of software development, from hands on programming to
                            project and team management. This experience has instilled in me the discipline and knowledge to deliver the best possible solutions that focus on you, the user.
                            <br><br>
                            With Truestock, I am excited to have the opportunity to make a positive impact on the creative community and enhance how our members conduct their business.
                        </p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 col-sm-3">
                        <img :src="`${assetsUrl}profile-photos/daniel-profile.jpg`" alt="Daniel Leddy">
                        <div class="info">
                            <div><strong>Daniel Leddy</strong></div>
                            <div>Director <span class="smaller">CA, LLB (Hons), BCom, Dip CII</span></div>
                            <div>daniel@truestock.co.nz</div>
                        </div>
                    </div>
                    <div class="col-12 col-sm-9">
                        <p>
                            I have worked in finance and insurance both in New Zealand and London for the past 15 years. I have had experience working in both small businesses and large multinational corporations, holding senior positions
                            including Finance Director and equity partner.
                            <br><br>
                            I studied Law (Hons) and Commerce at Auckland University and have a passion for New Zealand owned business. I am privileged to be involved in this project; the opportunity to establish a
                            <nobr>co-operative</nobr>
                            that will look to invest back into the creative industry, foster a community of collaboration and provide a platform to share life in Aotearoa both locally and globally.
                        </p>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>
<script>
export default {
    name: 'NzAbout'
}
</script>
